<template>
<div class="">
  <tour-operator-booking></tour-operator-booking>
</div>
</template>

<script>
import TourOperatorBooking from './Snippets/TourOperatorBooking'

export default {
  components: { TourOperatorBooking },
  name: 'new-partner-booking',
  data () {
    return {}
  },
  created () {
    this.$store.dispatch('get_all_destinations')
    this.$store.dispatch('get_all_conservation_fees')
    this.$store.dispatch('all_school_conservation_fees')
    this.$store.dispatch('get_all_vehicle_fees')
    // Necessary in order to remove items that were still in state after a previous booking
    localStorage.setItem('vehicle_data', JSON.stringify([]))
    localStorage.setItem('conservation_data', JSON.stringify([]))
    localStorage.setItem('facility_data', JSON.stringify([]))
    localStorage.setItem('activity_data', JSON.stringify([]))
    localStorage.setItem('old_facility_data', JSON.stringify([]))
    localStorage.setItem('old_activity_data', JSON.stringify([]))
    this.$store.commit('REMOVE_CHOSEN_FACILITIES')
    this.$store.commit('REMOVE_CHOSEN_ACTIVITIES')
  }
}
</script>

<style scoped>

</style>
